module.exports = "/images/Hub2b.png?409ef723bdaf5bd104422e8c18addf70";